import React from 'react';
import ReactDOM from 'react-dom';
import './index.less';
import App from './App';
// import App from './test/test';
import reportWebVitals from './reportWebVitals';
import { Providers } from './context/index';
import { CookiesProvider } from 'react-cookie';

ReactDOM.render(
  <React.StrictMode>
    <CookiesProvider>
      <Providers>
        <App />
      </Providers>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
